(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["h2o-product-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.h2oPdInit) return;
    window.h2oPdInit = true;
    if (!('onbeforematch' in document.body)) document.documentElement.classList.add('h2o-pd-nofind');

    function setOpen(section, btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = btn.querySelector('.h2o-pd__label');
      if (label) label.textContent = open ? btn.dataset.labelOpen : btn.dataset.labelClosed;
      if (open) {
        panel.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.classList.add('is-open'); });
        });
      } else {
        panel.classList.remove('is-open');
        var done = function (e) {
          if (e && e.target !== panel) return;
          panel.removeEventListener('transitionend', done);
          if (btn.getAttribute('aria-expanded') === 'false') panel.setAttribute('hidden', 'until-found');
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
        else panel.addEventListener('transitionend', done);
      }
    }

    function openOnly(section, target) {
      section.querySelectorAll('.h2o-pd__btn').forEach(function (b) {
        var want = b === target;
        if ((b.getAttribute('aria-expanded') === 'true') !== want) setOpen(section, b, want);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-h2o-pd] .h2o-pd__btn');
      if (!btn) return;
      var section = btn.closest('[data-h2o-pd]');
      if (btn.getAttribute('aria-expanded') === 'true') setOpen(section, btn, false);
      else openOnly(section, btn);
    });

    document.addEventListener('beforematch', function (e) {
      var panel = e.target.closest && e.target.closest('[data-h2o-pd] .h2o-pd__panel');
      if (!panel) return;
      var section = panel.closest('[data-h2o-pd]');
      var btn = section.querySelector('[aria-controls="' + panel.id + '"]');
      if (btn) openOnly(section, btn);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
